import actions from './actions';

export default {
  namespaced: false,
  state: () => ({
    surveyTypes: [{
      id: 'start_signup_suv',
      name: 'Survey for new users',
    },
    {
      id: 'end_suv',
      name: 'Questionnaire after an ended mentorship session',
    },
    ],
  }),
  actions,
};
